import { create } from 'zustand';

export interface PanelEntry {
  id: string;
  title: string;
  width: string;
  hasFooter: boolean;
  closing: boolean;
  onClose: () => void;
  bodyNode: HTMLDivElement;
  footerNode: HTMLDivElement;
}

interface SidePanelState {
  stack: PanelEntry[];
}

interface SidePanelActions {
  register: (entry: PanelEntry) => void;
  unregister: (id: string) => void;
  closeTop: () => void;
  closeAll: () => void;
}

export const useSidePanelStore = create<SidePanelState & SidePanelActions>(
  (set, get) => ({
    stack: [],
    // Upsert: re-registering an existing id replaces its data without moving
    // it in the stack, which is how an open panel syncs a changed title.
    register: (entry) =>
      set((s) =>
        s.stack.some((e) => e.id === entry.id)
          ? { stack: s.stack.map((e) => (e.id === entry.id ? entry : e)) }
          : { stack: [...s.stack, entry] },
      ),
    unregister: (id) =>
      set((s) => ({ stack: s.stack.filter((e) => e.id !== id) })),
    closeTop: () => {
      const { stack } = get();
      for (let i = stack.length - 1; i >= 0; i -= 1) {
        if (!stack[i].closing) {
          stack[i].onClose();
          return;
        }
      }
    },
    closeAll: () => {
      const { stack } = get();
      for (let i = stack.length - 1; i >= 0; i -= 1) {
        if (!stack[i].closing) stack[i].onClose();
      }
    },
  }),
);
